import { DestroyRef, Injectable, computed, inject, signal } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { lastValueFrom, tap } from "rxjs";
import { FeatureFlag } from "./feature-flags";
import { FeatureFlagsDataService } from "./feature-flags-data.service";
import { FeatureFlagsState } from "./feature-flags-state.model";

const initialState: Readonly<FeatureFlagsState> = {
  featureFlags: null,
};

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsFacadeService {
  readonly featureFlagsDataService = inject(FeatureFlagsDataService);
  readonly destroyRef = inject(DestroyRef);

  readonly state = signal(initialState);
  readonly featureFlags = computed(() => this.state().featureFlags);

  async loadFeatureFlags() {
    return await lastValueFrom(
      (await this.featureFlagsDataService.getFeatureFlags()).pipe(
        takeUntilDestroyed(this.destroyRef),
        tap((featureFlags) =>
          this.state.set({
            featureFlags,
          })
        )
      )
    );
  }

  featureFlagEnabled(featureFlag: FeatureFlag) {
    return this.featureFlags()?.[featureFlag] ?? false;
  }
}
